import React from 'react';
import PropTypes from 'prop-types';

const Clock = ({className = '', color = '#000'}) => {
  return (
    <svg className={className} width="16" height="15" viewBox="0 0 16 15">
      <g fill={color}>
        <path d="M14.401 4.58c-.79-1.843-2.134-3.184-3.994-3.977a7.372 7.372 0 0 0-2.92-.599c-1.016 0-1.983.2-2.91.599-1.844.79-3.194 2.13-3.987 3.977A7.299 7.299 0 0 0 0 7.492c0 1.017.194 1.994.59 2.92.793 1.846 2.143 3.194 3.986 3.985a7.296 7.296 0 0 0 2.912.599c1.017 0 1.99-.203 2.92-.599 1.858-.793 3.202-2.142 3.993-3.985A7.336 7.336 0 0 0 15 7.492c0-1.017-.2-1.983-.599-2.912zm-1.197 6.225a6.58 6.58 0 0 1-2.411 2.403 6.46 6.46 0 0 1-3.305.886 6.351 6.351 0 0 1-2.559-.525 6.706 6.706 0 0 1-2.1-1.402 6.665 6.665 0 0 1-1.402-2.108 6.457 6.457 0 0 1-.516-2.567c0-1.19.292-2.29.877-3.297a6.583 6.583 0 0 1 2.403-2.403A6.41 6.41 0 0 1 7.488.906a6.46 6.46 0 0 1 3.305.886 6.6 6.6 0 0 1 2.41 2.403 6.41 6.41 0 0 1 .887 3.297c0 1.189-.294 2.297-.886 3.313z" />
        <path d="M7.963 7.426V3.178a.473.473 0 0 0-.475-.46.462.462 0 0 0-.451.46v4.314c0 .008.016.04.016.065a.429.429 0 0 0 .123.37l2.452 2.452a.467.467 0 0 0 .632 0 .442.442 0 0 0 0-.64L7.963 7.426z" />
      </g>
    </svg>
  );
};

Clock.propTypes = {
  color: PropTypes.string,
  className: PropTypes.string,
};

export default Clock;
